// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════
   App Detail screen
   ════════════════════════════════════════════════════════ */

.ad-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8fafc;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  overflow: hidden;
}

/* Header */
.ad-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  background: #fff;
  border-bottom: 1.5px solid #e2e8f0;
  flex-shrink: 0;
}
.ad-back {
  width: 32px;
  height: 32px;
  border: 1.5px solid #e2e8f0;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  flex-shrink: 0;
  transition: background 0.15s;
}
.ad-back:hover { background: #f1f5f9; }
.ad-header-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }

/* Body */
.ad-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 16px 40px;
}

/* Hero card */
.ad-hero {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 14px;
  box-shadow: 0 1px 5px rgba(0,0,0,0.07);
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.ad-hero-logo {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  object-fit: contain;
  background: #f3f4f6;
  flex-shrink: 0;
}
.ad-hero-monogram {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 800;
  color: #fff;
}
.ad-hero-info { flex: 1; min-width: 0; }
.ad-hero-name { font-size: 18px; font-weight: 700; color: #111827; margin: 0 0 4px; }
.ad-hero-id   { font-size: 11px; color: #9ca3af; margin: 0 0 10px; }
.ad-hero-badges { display: flex; gap: 7px; flex-wrap: wrap; }

/* Section cards */
.ad-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ad-card-title {
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  margin: 0 0 12px;
}
.ad-desc-text { font-size: 14px; color: #374151; line-height: 1.6; margin: 0; }

/* Pricing table */
.ad-pricing-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}
.ad-pricing-row:last-child { border-bottom: none; }
.ad-pricing-cycle { font-size: 13px; font-weight: 600; color: #374151; }
.ad-pricing-right { display: flex; align-items: center; gap: 10px; }
.ad-pricing-price { font-size: 15px; font-weight: 700; color: #111827; }
.ad-pricing-gst   { font-size: 11px; color: #6b7280; }

/* Detail rows */
.ad-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px solid #f1f5f9;
}
.ad-detail-row:last-child { border-bottom: none; }
.ad-detail-label { font-size: 13px; color: #6b7280; }
.ad-detail-value { font-size: 13px; font-weight: 600; color: #111827; }

/* Badges (reuse same pattern) */
.ad-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
.ad-badge-green  { background: #dcfce7; color: #166534; }
.ad-badge-amber  { background: #fef3c7; color: #92400e; }
.ad-badge-gray   { background: #f3f4f6; color: #6b7280; }
.ad-badge-blue   { background: #dbeafe; color: #1e40af; }
.ad-badge-free   { background: #dcfce7; color: #166534; }

/* Dark mode */
.ad-container.dark { background: #18181b; }
.ad-container.dark .ad-header { background: #27272a; border-bottom-color: #3f3f46; }
.ad-container.dark .ad-header-title { color: #f4f4f5; }
.ad-container.dark .ad-back { background: #3f3f46; border-color: #52525b; color: #a1a1aa; }
.ad-container.dark .ad-hero,
.ad-container.dark .ad-card { background: #27272a; box-shadow: 0 1px 4px rgba(0,0,0,0.25); }
.ad-container.dark .ad-hero-name { color: #f4f4f5; }
.ad-container.dark .ad-hero-id   { color: #71717a; }
.ad-container.dark .ad-card-title { color: #71717a; }
.ad-container.dark .ad-desc-text { color: #a1a1aa; }
.ad-container.dark .ad-pricing-cycle { color: #d4d4d8; }
.ad-container.dark .ad-pricing-price { color: #f4f4f5; }
.ad-container.dark .ad-pricing-gst   { color: #71717a; }
.ad-container.dark .ad-detail-label  { color: #71717a; }
.ad-container.dark .ad-detail-value  { color: #e4e4e7; }
.ad-container.dark .ad-pricing-row,
.ad-container.dark .ad-detail-row    { border-bottom-color: #3f3f46; }
.ad-container.dark .ad-badge-gray  { background: #3f3f46; color: #a1a1aa; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/AppsIntegrations/AppDetail/index.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;AACA,iBAAiB,mBAAmB,EAAE;AACtC,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;;AAEjF,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,gBAAgB,OAAO,EAAE,YAAY,EAAE;AACvC,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpF,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnE,kBAAkB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE5D,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAE9E,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;AACA,6BAA6B,mBAAmB,EAAE;AAClD,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACnE,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,oBAAoB,eAAe,EAAE,cAAc,EAAE;;AAErD,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,mBAAmB,eAAe,EAAE,cAAc,EAAE;AACpD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEtE,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD,cAAc;AACd,qBAAqB,mBAAmB,EAAE;AAC1C,gCAAgC,mBAAmB,EAAE,4BAA4B,EAAE;AACnF,sCAAsC,cAAc,EAAE;AACtD,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1F;8BAC8B,mBAAmB,EAAE,sCAAsC,EAAE;AAC3F,mCAAmC,cAAc,EAAE;AACnD,mCAAmC,cAAc,EAAE;AACnD,oCAAoC,cAAc,EAAE;AACpD,mCAAmC,cAAc,EAAE;AACnD,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;AACvD,uCAAuC,cAAc,EAAE;AACvD;uCACuC,4BAA4B,EAAE;AACrE,qCAAqC,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* ════════════════════════════════════════════════════════\n   App Detail screen\n   ════════════════════════════════════════════════════════ */\n\n.ad-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: #f8fafc;\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  overflow: hidden;\n}\n\n/* Header */\n.ad-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  background: #fff;\n  border-bottom: 1.5px solid #e2e8f0;\n  flex-shrink: 0;\n}\n.ad-back {\n  width: 32px;\n  height: 32px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 50%;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #475569;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.ad-back:hover { background: #f1f5f9; }\n.ad-header-title { font-size: 15px; font-weight: 700; color: #0f172a; margin: 0; }\n\n/* Body */\n.ad-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 16px 40px;\n}\n\n/* Hero card */\n.ad-hero {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 14px;\n  box-shadow: 0 1px 5px rgba(0,0,0,0.07);\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n.ad-hero-logo {\n  width: 64px;\n  height: 64px;\n  border-radius: 14px;\n  object-fit: contain;\n  background: #f3f4f6;\n  flex-shrink: 0;\n}\n.ad-hero-monogram {\n  width: 64px;\n  height: 64px;\n  border-radius: 14px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 800;\n  color: #fff;\n}\n.ad-hero-info { flex: 1; min-width: 0; }\n.ad-hero-name { font-size: 18px; font-weight: 700; color: #111827; margin: 0 0 4px; }\n.ad-hero-id   { font-size: 11px; color: #9ca3af; margin: 0 0 10px; }\n.ad-hero-badges { display: flex; gap: 7px; flex-wrap: wrap; }\n\n/* Section cards */\n.ad-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px 18px;\n  margin-bottom: 12px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n}\n.ad-card-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  margin: 0 0 12px;\n}\n.ad-desc-text { font-size: 14px; color: #374151; line-height: 1.6; margin: 0; }\n\n/* Pricing table */\n.ad-pricing-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.ad-pricing-row:last-child { border-bottom: none; }\n.ad-pricing-cycle { font-size: 13px; font-weight: 600; color: #374151; }\n.ad-pricing-right { display: flex; align-items: center; gap: 10px; }\n.ad-pricing-price { font-size: 15px; font-weight: 700; color: #111827; }\n.ad-pricing-gst   { font-size: 11px; color: #6b7280; }\n\n/* Detail rows */\n.ad-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.ad-detail-row:last-child { border-bottom: none; }\n.ad-detail-label { font-size: 13px; color: #6b7280; }\n.ad-detail-value { font-size: 13px; font-weight: 600; color: #111827; }\n\n/* Badges (reuse same pattern) */\n.ad-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n.ad-badge-green  { background: #dcfce7; color: #166534; }\n.ad-badge-amber  { background: #fef3c7; color: #92400e; }\n.ad-badge-gray   { background: #f3f4f6; color: #6b7280; }\n.ad-badge-blue   { background: #dbeafe; color: #1e40af; }\n.ad-badge-free   { background: #dcfce7; color: #166534; }\n\n/* Dark mode */\n.ad-container.dark { background: #18181b; }\n.ad-container.dark .ad-header { background: #27272a; border-bottom-color: #3f3f46; }\n.ad-container.dark .ad-header-title { color: #f4f4f5; }\n.ad-container.dark .ad-back { background: #3f3f46; border-color: #52525b; color: #a1a1aa; }\n.ad-container.dark .ad-hero,\n.ad-container.dark .ad-card { background: #27272a; box-shadow: 0 1px 4px rgba(0,0,0,0.25); }\n.ad-container.dark .ad-hero-name { color: #f4f4f5; }\n.ad-container.dark .ad-hero-id   { color: #71717a; }\n.ad-container.dark .ad-card-title { color: #71717a; }\n.ad-container.dark .ad-desc-text { color: #a1a1aa; }\n.ad-container.dark .ad-pricing-cycle { color: #d4d4d8; }\n.ad-container.dark .ad-pricing-price { color: #f4f4f5; }\n.ad-container.dark .ad-pricing-gst   { color: #71717a; }\n.ad-container.dark .ad-detail-label  { color: #71717a; }\n.ad-container.dark .ad-detail-value  { color: #e4e4e7; }\n.ad-container.dark .ad-pricing-row,\n.ad-container.dark .ad-detail-row    { border-bottom-color: #3f3f46; }\n.ad-container.dark .ad-badge-gray  { background: #3f3f46; color: #a1a1aa; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
